// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fj-0";
export var fulfillmentPanelBody = "_fj-1";